export class AgentSessionStartEvent {
  constructor(json) {
    this.type = json.Type;
    this.busNo = json.BusNo;
    this.agentId = json.AgentId;
    this.sessionId = json.SessionId;
    this.stationPhoneNumber = json.StationPhoneNumber;
    this.stationCallerId = json.StationCallerId;
    this.dialerCampaign = json.DialerCampaign;
    this.dialerCampaignStartTime = json.DialerCampaignStartTime;
    this.supervisorPermissionLevel = json.SupervisorPermissionLevel;
    this.canMask = json.CanMask;
    this.agentSchedulePermission = json.AgentSchedulePermission;
    this.scoreRecordingsPermission = json.ScoreRecordingsPermission;
    this.hideAgentStatePermission = json.HideAgentStatePermission;
  }

  get description() {
    return `${this.type} #${this.sessionId}`;
  }
}
